/* eslint-disable @tencent/i18next/no-literal-string */
import { ActionPointInfo, IActionPointInfo, IMiddleware, Middleware } from '@tencent/workbench';
import { vipTabReport } from '../ui/vip-service/report';
import { FIXED_KEYS_DOUBLE } from '../schema/constant';
import { ActionType } from '@src/framework/editor/src/js/constants/common-action-type';
import { wrapIdForBig, wrapIdForVip } from '../util/wrap-id-util';

const vipFeatureNameMap = {
    [ActionType.VIP_CENTER]: 'vipservice',
    [wrapIdForBig(ActionType.EXPORT_IMAGE)]: 'slide2pic',
    [wrapIdForBig(ActionType.PDF_TRANSFORM)]: 'pdf2office',
    [ActionType.UNIFORM_FONT_TOOLBAR]: 'unifyfont',
    [wrapIdForVip(ActionType.MUTI_PICTURE_EXPORT)]: 'batdownloadpic',
    [wrapIdForVip(ActionType.MUTI_PICTURE_POS_SETTING)]: 'batsetpiclay',
    [wrapIdForVip(ActionType.MUTI_PICTURE_SIZE_SETTING)]: 'batsetpicsize',
    [wrapIdForVip(ActionType.OCR_PICTURE)]: 'slideocr',
    [ActionType.CHANGE_TEMPLATE_CONTENT]: 'template',
    [ActionType.CHANGE_TEMPLATE_MORE]: 'moretemplate',
    [ActionType.MORE_VIP_PRIVILEGES]: 'moreprivilege',
    [ActionType.PDF_TO_WORD]: 'pdf2word',
    [ActionType.PDF_TO_EXCEL]: 'pdf2excel',
    [ActionType.PDF_TO_PPT]: 'pdf2ppt',
};

@Middleware()
export class VipTabReportMiddleWare implements IMiddleware {
    public use(@ActionPointInfo() info: IActionPointInfo) {
        const { name } = info;

        const shouldReport = this.shouldTriggerReport(info);
        if (!shouldReport) {
            return;
        }

        const ver7 = vipFeatureNameMap[name];
        if (ver7) {
            vipTabReport('tool_vip_toolmenu', 'click', ver7);
        }
    }

    private shouldTriggerReport(info: IActionPointInfo) {
        return info.path.includes(FIXED_KEYS_DOUBLE.TOOLBAR_VIP);
    }
}
